import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { theme } from "../../../../../../helpers/theme";
import { deleteWarehousesImage } from "../../../../../../services/warehouses-images/delete-image";
import { getAllWarehouses } from "../../../../../../services/warehouses/get-all";
import { WarehousesGallery } from "../../../../../../services/warehouses/get-all/types";

interface DeleteButtonProps {
  MagazynId: string;
  zdjecie_id: string;
  url: string;
  setImagesList: (imagesList: WarehousesGallery[]) => void;
  setIsGalleryLoading:(isGalleryLoading: boolean) => void;
}

export const DeleteButton = ({
  MagazynId,
  zdjecie_id,
  url,
  setImagesList,
  setIsGalleryLoading,
}: DeleteButtonProps) => {

    const getAllWarehousesMutation = useMutation(getAllWarehouses, {
        onSuccess: (res) => {
           setImagesList(res.data.payload.magazyny[0].zdjecia_magazynu)
           setIsGalleryLoading(false)
        },
      });
    

  const deleteWarehousesImageMutation = useMutation(deleteWarehousesImage, {
    onSuccess: (res) => {
      setIsGalleryLoading(true)
      getAllWarehousesMutation.mutate({
        paginacja: null,
        filtr: {
          id_magazyn: MagazynId,
        },
      });
    },
    onError: (err: any) => {},
  });

  const handleDeleteImage = () => {
    deleteWarehousesImageMutation.mutate({
      zdjecie_id: zdjecie_id,
    });
  };

  return (
    <IconButton
      sx={{ padding: "0px" }}
      aria-label="delete"
      onClick={handleDeleteImage}
    >
      <DeleteIcon
        sx={{
          color: `${theme.colors.gray01_secondaryText}`,
          ":hover": {
            color: `${theme.colors.blue01_active}`,
          },
        }}
      />
    </IconButton>
  );
};
